var _defs, _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 372.26 524.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 80.85,
    y: 206.43,
    width: 196.04,
    height: 161.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 118.23,
    y: 86.68,
    width: 120.76,
    height: 120.76
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.16,265.12c0-14.42-11.7-26.12-26.12-26.12s-26.12,11.7-26.12,26.12c0,9.66,5.26,18.08,13.06,22.6v47.36h26.12v-47.36c7.8-4.52,13.06-12.94,13.06-22.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.76,198.51h-23.09V115.18c0-14.33-11.66-25.99-25.99-25.99h-57.28c-14.33,0-25.98,11.66-25.98,25.99v83.33h-23.09V115.18c0-27.07,22.01-49.08,49.07-49.08h57.28c27.07,0,49.08,22.02,49.08,49.08v83.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.89,386.09H95.2c-19.1,0-34.63-15.53-34.63-34.63v-127.71c0-19.1,15.53-34.63,34.63-34.63h165.7c19.1,0,34.63,15.53,34.63,34.63v127.71c0,19.1-15.53,34.63-34.63,34.63ZM95.2,212.21c-6.37,0-11.54,5.18-11.54,11.54v127.71c0,6.36,5.18,11.54,11.54,11.54h165.7c6.36,0,11.54-5.18,11.54-11.54v-127.71c0-6.36-5.18-11.54-11.54-11.54H95.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.65f8ebc05d182bb5a6d17ccc29a005f3.svg";
export { ForwardRef as ReactComponent };